// supported languages
export var Language;
(function (Language) {
    Language["en"] = "en";
    Language["cs"] = "cs";
    Language["pl"] = "pl";
    Language["de"] = "de";
    Language["it"] = "it";
})(Language || (Language = {}));
